"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconWrapper = exports.StyledTextInput = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _noop2 = _interopRequireDefault(require("lodash-es/noop"));

var _isEqual2 = _interopRequireDefault(require("lodash-es/isEqual"));

var _icon = _interopRequireDefault(require("../icon"));

var _fontIcon = _interopRequireDefault(require("../font-icon"));

var _input = require("../_input");

var _label = _interopRequireDefault(require("../label"));

var _context = require("../../context");

var _versions = require("../../_utils/versions");

var _utilities = require("../../_utils/utilities");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    right: 0;\n    padding-right: 12px;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    padding-right: 12px;\n    > span, > svg {\n      display: inline-block;\n      margin-top: ", ";\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  position: absolute;\n  height: ", ";\n  border-right: ", ";\n  border-left: ", ";\n\n  top: ", ";\n\n  padding-left: ", ";\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  padding-top: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getStyles = function getStyles() {};

var fetchStyles = function fetchStyles(props) {
  var properties = (0, _versions.getProperties)(props, 'input');

  getStyles = function getStyles() {
    return properties;
  };
};

var StyledTextInput = _styledComponents["default"].div(_templateObject(), function (props) {
  var bordered = props.bordered;
  var value = 0;

  if (props.label) {
    value = '16px';
  }

  if (props.label && bordered) {
    value = '20px';
  }

  return value;
});

exports.StyledTextInput = StyledTextInput;

var WithErrorContainer = _styledComponents["default"].div(_templateObject2(), function (props) {
  var bordered = props.bordered;
  var value = 60;

  if (props.label) {
    value = 75;
  }

  if (props.label && bordered) {
    value = 80;
  }

  if (props.size === 'medium') {
    value = value - 10;
  }

  if (props.assistive) {
    value = value + 17;
  }

  if (props["native"]) {
    return 'initial';
  }

  return "".concat(value, "px");
});

var IconWrapper = _styledComponents["default"].div(_templateObject3(), function (props) {
  return props.bordered && (props.iconBordered || props.rightIconBordered) && (0, _styledComponents.css)(_templateObject4(), function (props) {
    return props.size === 'medium' ? '8px' : '10px';
  });
}, function (props) {
  return props.bordered && (props.iconBordered || props.rightIconBordered) && props.height[props.size];
}, function (props) {
  return props.bordered && !props.isRightIcon && props.icon && props.iconBordered && "1px solid ".concat((0, _versions.getColor)(props, 'input').border);
}, function (props) {
  return props.bordered && props.isRightIcon && props.rightIcon && props.rightIconBordered && "1px solid ".concat((0, _versions.getColor)(props, 'input').border);
}, function (props) {
  var _getStyles = getStyles(),
      top = _getStyles.iconStyle.top;

  if (props.iconBordered || props.rightIconBordered) {
    top = top.bordered;
  }

  var value = top["default"];

  if (props.label) {
    if (!props.bordered) {
      value = top.withLabel.noBorder;
    }

    if (props.size === 'medium') {
      value = top.withLabel.medium;
    }

    if (props.bordered && props.size === 'medium') {
      value = top.withLabel.mediumBordered;
    }
  } else {
    value = top.withoutLabel["default"];

    if (props.bordered && props.size === 'medium') {
      value = top.withoutLabel.mediumBordered;
    }

    if (!props.bordered && props.size === 'medium') {
      value = top.withoutLabel.medium;
    }
  }

  return value;
}, function (props) {
  var bordered = props.bordered;

  if (!bordered) {
    return 0;
  }

  return '12px';
}, function (props) {
  return props.isRightIcon && (0, _styledComponents.css)(_templateObject5());
});

exports.IconWrapper = IconWrapper;

var getIcon = function getIcon(props, properties) {
  var rightIcon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var icon = rightIcon ? props.rightIcon : props.icon;

  if (_utilities.iconPattern.test(icon)) {
    return _react["default"].createElement(IconWrapper, _extends({}, props, properties, {
      isRightIcon: rightIcon
    }), _react["default"].createElement(_fontIcon["default"], {
      size: 14
    }, icon));
  }

  return _react["default"].createElement(IconWrapper, _extends({}, props, properties, {
    isRightIcon: rightIcon
  }), _react["default"].createElement(_icon["default"], {
    name: icon,
    size: 14
  }));
};

var TextInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TextInput, _React$Component);

  //eslint-disable-line
  function TextInput(props) {
    var _this;

    _classCallCheck(this, TextInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextInput).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "componentWillReceiveProps", function (nextProps) {
      if (!(0, _isEqual2["default"])(nextProps.value, _this.state.value)) _this.setState({
        value: nextProps.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getEvents", function () {
      var events = {};
      var eventName = ['onChange', 'onBlur', 'onFocus', 'onKeyDown', 'onKeyUp', 'onKeyPress'];
      eventName.forEach(function (event) {
        if (_this.props[event] || event === 'onChange') {
          events[event] = function (e) {
            e.persist();

            if (_this.props.value || _this.props.value === '') {
              _this.props[event](e);
            } else {
              var value = e.target.value;

              _this.setState({
                value: value
              }, function () {
                return _this.props[event](e);
              });
            }
          };
        }
      });
      return events;
    });

    _this.state = {
      value: props.value || props.defaultValue || ''
    };
    fetchStyles(props);
    return _this;
  }

  _createClass(TextInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          onBlur = _this$props.onBlur,
          onKeyDown = _this$props.onKeyDown,
          onKeyPress = _this$props.onKeyPress,
          onKeyUp = _this$props.onKeyUp,
          onFocus = _this$props.onFocus,
          defaultValue = _this$props.defaultValue,
          className = _this$props.className,
          tabIndex = _this$props.tabIndex,
          innerRef = _this$props.innerRef,
          name = _this$props.name,
          autoFocus = _this$props.autoFocus,
          labelStyle = _this$props.labelStyle,
          labelClassName = _this$props.labelClassName,
          autoComplete = _this$props.autoComplete,
          inputProps = _objectWithoutProperties(_this$props, ["onChange", "onBlur", "onKeyDown", "onKeyPress", "onKeyUp", "onFocus", "defaultValue", "className", "tabIndex", "innerRef", "name", "autoFocus", "labelStyle", "labelClassName", "autoComplete"]);

      var properties = getStyles();

      if (inputProps.masked) {
        var length = defaultValue ? defaultValue.length : 8;
        var maskedValue = new Array(length).join('•');
        return _react["default"].createElement("div", {
          className: className
        }, _react["default"].createElement(StyledTextInput, _extends({}, inputProps, properties), inputProps.icon && getIcon(inputProps, properties), inputProps.rightIcon && getIcon(inputProps, properties, true), _react["default"].createElement(TextInput.Element, _extends({}, inputProps, properties, {
          name: name,
          autoFocus: autoFocus,
          innerRef: innerRef,
          placeholder: maskedValue,
          autoComplete: autoComplete,
          readOnly: true,
          tabIndex: tabIndex
        })), _react["default"].createElement(_input.StyledLabel, _extends({
          style: labelStyle,
          className: labelClassName,
          readOnly: true
        }, inputProps, properties), inputProps.label)), inputProps.assistive && _react["default"].createElement(_label["default"], {
          type: "assistive"
        }, inputProps.assistive));
      }

      if (!inputProps.label || inputProps.label === '') {
        return _react["default"].createElement(WithErrorContainer, _extends({}, inputProps, {
          className: className
        }), _react["default"].createElement(StyledTextInput, _extends({}, inputProps, properties), inputProps.icon && getIcon(inputProps, properties), inputProps.rightIcon && getIcon(inputProps, properties, true), _react["default"].createElement(TextInput.Element, _extends({}, inputProps, properties, this.getEvents(), {
          innerRef: innerRef,
          name: name,
          autoFocus: autoFocus,
          autoComplete: autoComplete,
          value: this.state.value,
          required: true,
          tabIndex: tabIndex
        }))), inputProps.assistive && _react["default"].createElement(_label["default"], {
          type: "assistive"
        }, inputProps.assistive), _react["default"].createElement(_input.StyledError, _extends({}, properties, {
          version: inputProps.version
        }), inputProps.error));
      } else {
        var placeholder = inputProps.placeholder,
            rest = _objectWithoutProperties(inputProps, ["placeholder"]);

        return _react["default"].createElement(WithErrorContainer, _extends({}, inputProps, {
          className: className
        }), _react["default"].createElement(StyledTextInput, _extends({}, inputProps, properties), inputProps.icon && getIcon(inputProps, properties), inputProps.rightIcon && getIcon(inputProps, properties, true), _react["default"].createElement(TextInput.Element, _extends({
          placeholder: properties.labelType === 'floating' ? null : placeholder
        }, rest, properties, this.getEvents(), {
          name: name,
          autoFocus: autoFocus,
          autoComplete: autoComplete,
          innerRef: innerRef,
          required: true,
          tabIndex: tabIndex
        })), _react["default"].createElement(_input.StyledLabel, _extends({
          style: labelStyle,
          className: labelClassName
        }, inputProps, properties), inputProps.label)), inputProps.assistive && _react["default"].createElement(_label["default"], {
          type: "assistive"
        }, inputProps.assistive), _react["default"].createElement(_input.StyledError, _extends({
          version: inputProps.version
        }, properties), inputProps.error));
      }
    }
  }]);

  return TextInput;
}(_react["default"].Component);

TextInput.Element = _input.StyledInput;
TextInput.propTypes = {
  icon: _propTypes["default"].string,
  rightIcon: _propTypes["default"].string,
  "native": _propTypes["default"].bool,
  bordered: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  masked: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  iconBordered: _propTypes["default"].bool,
  code: _propTypes["default"].bool,
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),
  size: _propTypes["default"].oneOf(['large', 'medium']),
  onChange: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  defaultValue: _propTypes["default"].string
};
TextInput.defaultProps = {
  "native": false,
  bordered: false,
  required: false,
  readOnly: false,
  code: false,
  error: null,
  size: 'large',
  onChange: _noop2["default"],
  onKeyDown: _noop2["default"],
  onKeyPress: _noop2["default"],
  onKeyUp: _noop2["default"],
  onFocus: _noop2["default"],
  onBlur: _noop2["default"],
  iconBordered: false,
  rightIconBordered: false,
  labelClassName: '',
  labelStyle: {},
  autoComplete: undefined
};
TextInput.displayName = 'TextInput';

var _default = (0, _context.withVersion)(TextInput);

exports["default"] = _default;